import { SignIn } from "@clerk/clerk-react";

export default function SignInPage() {
  return (
    <main className="min-h-screen w-full flex items-center justify-center bg-lucid-deep px-6 py-10">
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" afterSignInUrl="/play" />
    </main>
  );
}
